import React from 'react';

const pageStyle = { maxWidth: '720px', margin: '0 auto', padding: '3rem 1.5rem', lineHeight: 1.7, color: '#2d3436' };
const h1Style = { fontSize: '1.8rem', marginBottom: '2rem' };
const h2Style = { fontSize: '1.15rem', marginTop: '2rem', marginBottom: '0.5rem' };

const MentionsLegales = () => (
  <div style={pageStyle}>
    <a href="/" style={{ fontSize: '0.85rem' }}>← Retour à l'accueil</a>
    <h1 style={h1Style}>Mentions légales</h1>

    <h2 style={h2Style}>Éditeur du site</h2>
    <p>
      Le site mypasserelle.com est édité par <strong>Passerelle</strong>, société par actions
      simplifiée unipersonnelle (SASU) au capital de 100 €, immatriculée au RCS de Nancy sous
      le numéro 102 911 583, dont le siège social est situé 8 rue Bellevue,
      54200 Villey-Saint-Étienne. N° TVA intracommunautaire : FR57102911583.
    </p>
    <p>
      Directrice de la publication : Anne Varnerot, Présidente.<br />
      Contact : <a href="mailto:anne@mypasserelle.com">anne@mypasserelle.com</a>
    </p>

    <h2 style={h2Style}>Hébergement</h2>
    <p>
      Le site est hébergé par Vercel Inc., 340 S Lemon Ave #4133, Walnut, CA 91789, États-Unis
      (<a href="https://vercel.com" target="_blank" rel="noreferrer">vercel.com</a>).
    </p>
    <p>
      Les données transmises via les formulaires du site sont stockées par Supabase sur des
      serveurs situés dans l'Union européenne (Stockholm, Suède).
    </p>

    <h2 style={h2Style}>Propriété intellectuelle</h2>
    <p>
      L'ensemble des contenus du site (textes, visuels, logo, marque Passerelle) est la
      propriété exclusive de la société Passerelle. Toute reproduction sans autorisation
      préalable est interdite.
    </p>

    <h2 style={h2Style}>Données personnelles</h2>
    <p>
      Le traitement des données personnelles collectées sur ce site est décrit dans la{' '}
      <a href="/politique-confidentialite">politique de confidentialité</a>.
    </p>
  </div>
);

export default MentionsLegales;
